export interface globalType {
  isOpenTopAlert: boolean;
}

export interface topAlertContent {
  iconType: string;
  message: any;
  iconClose: string;
}

export const initialTopAlertontent = {
  iconType: 'la la-exclamation-circle',
  message:
    'Please check your Policy Number on your billing statement or any other policy document and enter the Authorized Payer’s Date of Birth. You may also chat with us for assistance.',
  iconClose: 'la la-times',
};
